<template><section>
<h1>Button group</h1>
<p>Group a series of buttons together on a single line with the button group, and super-power them with JavaScript.</p>
<demo clz="">
                    <bs-button-group>
  <bs-button-item v-model="model1" value="left" type="secondary">Left</bs-button-item>
  <bs-button-item v-model="model1" value="middle" type="secondary">Middle</bs-button-item>
  <bs-button-item v-model="model1" value="right" type="secondary">Right</bs-button-item>
</bs-button-group>

                    <template slot="desp"><p>Basic example</p>
</template>
                    <template slot="source">
                    <pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">bs-button-group</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">bs-button-item</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"model1"</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"left"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"secondary"</span>&gt;</span>Left<span class="hljs-tag">&lt;/<span class="hljs-name">bs-button-item</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">bs-button-item</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"model1"</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"middle"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"secondary"</span>&gt;</span>Middle<span class="hljs-tag">&lt;/<span class="hljs-name">bs-button-item</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">bs-button-item</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"model1"</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"right"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"secondary"</span>&gt;</span>Right<span class="hljs-tag">&lt;/<span class="hljs-name">bs-button-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">bs-button-group</span>&gt;</span>
</code></pre>
</template></demo>
</section></template>

<script>
export default {
  data () {
    return {
      model1: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// example/views/components/ButtonGroup.vue?89ccb578